export default "__VITE_ASSET__CPrXxGjN__"